export default "__VITE_ASSET__mfm7f5xy__"